// initial state
import * as base from "./base.js";
const reverbName = "/admin/api/commodity";

const obj = base.setBaseUrl("commodity", reverbName);
const obj1 = base.setBaseUrl("verify", reverbName);
const a = Object.assign(obj, { obj1 });
export default a;
